import { DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

export default function Terms() {
    return (
        <div>
            <DialogTitle id="alert-dialog-slide-title">
                TERMS OF PARTICIPATION
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    I acknowledge my understanding and agree that…
                    <br />
                    <br /> My Gift of Legacy (GL) account is an asset. I can
                    participate in the Gift of Legacy gifting activity or turn
                    it over to others as long as my conduct matches the Terms &
                    Conditions as listed below
                    <br />
                    <br />1 - Gift of Legacy is a gifting activity and not an
                    investment nor a business activity. The speed of progress
                    from one board to another is not guaranteed nor predicted,
                    but is related to the pace of participation by the other
                    participants on the boards.
                    <br />
                    <br />2 - The spirit and conduct of Participants in Gift of
                    Legacy is to come together as a community creating abundance
                    for all, uplifting all participants in good standing, to
                    make and receive unconditional gifts by gifting generously,
                    and receiving graciously
                    <br />
                    <br />3 - Gift of Legacy is not responsible for any aspect
                    of the financial gifting transaction between myself and any
                    other Participants. The financial form of each gift is to be
                    agreed to between myself and Legend (receiver) when I am the
                    Gifter, and with Gifters when I am the Legend.
                    <br />
                    <br />
                    In addition to the gift amount, the sender of the gift is
                    always responsible for the sending transaction costs on
                    their side. The Legend (receiver) is always responsible for
                    receiving transaction costs on their side.
                    <br />
                    <br />4 - My participation in GL will begin with a position
                    as a Gifter on a $100 board position and requires me to make
                    an unconditional gift to the Legend on that board and
                    register 2 invitees in the platform by the time I become
                    Legend on the $100 board.
                    <br />
                    <br />5 - Taking into account the fact that Participants are
                    distributed in time zones around the world, I will initiate
                    communication between the myself and the Legend (receiver of
                    the gift) within 48 hours of placement on a board.
                    <br />
                    <br />6 - Upon progressing to the Legend position on any
                    board, I will confirm each received gift in the GL platform
                    as soon as received on my end or acceptable proof of
                    transaction is provided.
                    <br />
                    <br />7 - The communication time frame and gifting
                    transactions terms and conditions are identical on each
                    level in which I participate.
                    <br />
                    <br />
                    8 - Acknowledging that life and external events may prevent
                    immediate communication, Gifters may be removed from a board
                    if they inform the Legend they are unable to make their gift
                    at that time OR if multiple attempts have been unsuccessful
                    to communicate with them through their email, phone number,
                    community channels, and admin reaching out to next of kin.
                    <br />
                    <br />
                    9 - If the legend does not respond within 72 hours, the
                    system will put them on the sideline so that everyone can
                    continue on upwards, and they will be required to start
                    again. It is very important that as a Legend you are totally
                    engaged and available in the program
                    <br />
                    <br />
                    10 - The system algorithm will move my positions off of the
                    boards (to a ‘sideline’ position) until there are 2
                    confirmed invitees in good standing and gifts have been made
                    and confirmed in the system.
                    <br />
                    <br />
                    11 - When Fast Tracking is made available to me, it is an
                    option for me to use that feature, not an obligation. If I
                    choose to use it, both communication and my unconditional
                    gift will made to the Legend in a timely fashion on each new
                    level upon placement as a Gifter.
                    <br />
                    <br />
                    12 - When Cloning is made available to a me and I choose to
                    use it, my unconditional gift will made to the Legend on
                    each new $100 board and 2 invitees be registered by me in
                    the platform by the time I become Legend on that board.
                </DialogContentText>
            </DialogContent>
        </div>
    );
}
